import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

export enum Theme {
    DARK = "dark",
    LIGHT = "light",
}
interface ThemeContextType {
    toggleTheme: () => void;
    theme: Theme;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
    const [theme, setThemeMode] = useState(() => {
        const storedTheme = localStorage.getItem('theme') as Theme ?? Theme.DARK;
        return storedTheme;
    });

    const toggleTheme = () => {
        setThemeMode((prevMode: Theme) => prevMode === Theme.DARK ? Theme.LIGHT : Theme.DARK);
    };

    useEffect(() => {
        localStorage.setItem('theme', theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ toggleTheme, theme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme should be used within the ThemeProvider.');
    }
    return context;
};